import React, { useState } from 'react';
import { useSnapshot } from 'valtio';
import { ExpansionInfos, sideBarState } from '../sidebar-state';
import IconButton from '@mui/material/IconButton';
import TextField from '@mui/material/TextField';
import Popover from '@mui/material/Popover';
import Tooltip from '@mui/material/Tooltip';
import IconInfo from '~icons/mdi/information-outline';
import IconClose from '~icons/mdi/close';
import styled from '@emotion/styled';
import { useAppSelector } from '@/redux/hooks';

type TipsProps = {
  content: ExpansionInfos['resourcesTips'];
  highlight: boolean;
};

const PopoverContent = styled.div`
  display: grid;
  grid-template-rows: auto 1fr;
  max-height: 90vh;
`;

const TipsContentContainer = styled.div`
  font-size: 0.8rem;
  padding: 1.5rem;
  padding-top: 0;
  overflow-y: auto;

  h1 {
    margin-top: 0;
  }
`;

const TipsTopBar = styled.div`
  display: flex;
  justify-content: end;
`;

const Tips = (props: TipsProps) => {
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? 'tips-popover' : undefined;

  return (
    <>
      <Tooltip arrow title='Detailed information about the competency'>
        <IconButton
          aria-describedby={id}
          size='small'
          color='info'
          onClick={handleClick}
        >
          <IconInfo />
        </IconButton>
      </Tooltip>

      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left'
        }}
      >
        <PopoverContent>
          <TipsTopBar>
            <IconButton
              onClick={() => setAnchorEl(null)}
              sx={{ postion: 'absolute', right: 0 }}
            >
              <IconClose />
            </IconButton>
          </TipsTopBar>
          <TipsContentContainer>
            {props.content?.elementRef}
          </TipsContentContainer>
        </PopoverContent>
      </Popover>
    </>
  );
};

const SkillBarContainer = styled.div`
  display: grid;
  grid-template-columns: auto 1fr;
  align-content: center;
`;

export const SkillBar = () => {
  const skillbar = useAppSelector((state) => state.skillBar);
  const skillName =
    skillbar.skillName === 'Network Error' ? 'Capstone' : skillbar.skillName;

  const {
    expansionInfos: { feedback, resourcesTips }
  } = useSnapshot(sideBarState);
  const tips = resourcesTips;
  const highlightTips =
    feedback?.elementRef !== undefined && feedback?.style !== 'Correct';

  return (
    <SkillBarContainer>
      {tips && <Tips content={tips} highlight={highlightTips} />}
      <TextField 
        variant='outlined'
        InputProps={{
          readOnly: true,
          style: { fontSize: '.8rem' }
        }}
        InputLabelProps={{
          style: { fontSize: '.8rem' }
        }}
        label='Competency'
        defaultValue={skillName}
      />
    </SkillBarContainer>
  );
};

export default SkillBar;
